module.exports = "//Linear\n<LinearProgress mode=\"determinate\" value={60} />\n<LinearProgress mode=\"indeterminate\"  />\n<LinearProgress mode=\"determinate\" color={\"#4CAF50\"} value={60} />\n\n//Circular\n<CircularProgress mode=\"determinate\" value={60} />\n<CircularProgress mode=\"determinate\" value={60} size={1.5} />\n<CircularProgress mode=\"determinate\" value={60} size={2} />\n<CircularProgress mode=\"indeterminate\" />\n<CircularProgress mode=\"indeterminate\" size={1.5} />\n<CircularProgress mode=\"indeterminate\" color={\"red\"} size={2} />\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/raw-code/progress-code.txt
 ** module id = 841
 ** module chunks = 0
 **/